import React from "react";
import UserAvatar from "./UserAvatar";

const MessageBubble = ({ message, currentUserId }) => {
  const senderName =
    message.sender?.roleId?.name === "support" ||
    message.sender?.roleId?.name === "super admin"
      ? "Ghorfatech Support"
      : `${message.sender?.firstName || ""} ${message.sender?.lastName || ""}`.trim();

  const time = new Date(
    message.updatedAt || message.createdAt,
  ).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="flex items-start gap-2 md:gap-3 px-2 md:px-3 py-1.5 md:py-2">
      <UserAvatar
        user={message.sender}
        size="sm"
        isSupport={
          message.sender?.roleId?.name === "support" ||
          message.sender?.roleId?.name === "super admin"
        }
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-baseline gap-2">
          <span className="text-xs md:text-sm font-semibold dark:text-white">
            {senderName || "Unknown"}
          </span>
          <span className="text-[10px] md:text-xs text-gray-400">{time}</span>
        </div>
        <p className="mt-1 text-xs md:text-sm text-gray-700 dark:text-gray-300 whitespace-pre-wrap break-words">
          {message.content}
        </p>
      </div>
    </div>
  );
};

export default MessageBubble;
